import { cn } from '@/clientOnlyUtils/cn';
import { type ComponentProps, useEffect, useState } from 'react';

export type NotificationLabelProps = ComponentProps<'div'> & {
  counterValue: number;
};
const NotificationLabel = ({ className, counterValue }: NotificationLabelProps) => {
  const [isShaking, setIsShaking] = useState(false);

  useEffect(() => {
    if (counterValue !== 0) {
      setIsShaking(true);
      setTimeout(() => {
        setIsShaking(false);
      }, 1000);
    }
  }, [counterValue]);

  if (counterValue <= 0) {
    return null;
  }

  return (
    <div
      className={cn(
        'min-w-4.5 absolute right-2 top-1/2 flex -translate-y-1/2 items-center justify-center rounded-full bg-red-600 p-1 text-2xs font-bold leading-none text-white',
        { 'animate-shakeX': isShaking },
        className,
      )}>
      {counterValue > 99 ? '99+' : counterValue}
    </div>
  );
};

export default NotificationLabel;
